console.log("app.js from plugin on top");

// import libraries
import Handlebars from "handlebars";
//import { pagination } from "/node_modules/paginate-next/dist/paginationts.js";
import { pagination } from "paginate-next";
//import "./node_modules/paginate-next/dist/pagination.css";
import L from "leaflet";
import "leaflet.markercluster";
//console.log(pagination);

// import libraries CSS
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

const dataContainer = document.querySelector("#listing-container");
const brokerDataContainer = document.querySelector("#agents-container");
const paginationContainer = document.querySelector("#pagination-container");
const listingSection = document.getElementById("listing-section");
const brokersSection = document.querySelector(".our-agent-listing");
const regionCode = dataContainer.data("region");
const agentCode = dataContainer.data("agent");
const propertyTypeCode = dataContainer.data("type");
const municipalityCode = dataContainer.data("municipality");
const form = document.querySelector("#advanced--search");
const sale_status = document.querySelector('select[name="sale_status"]');
const minPrice = document.querySelector(".price_min");
const maxPrice = document.querySelector(".price_max");
let type__select = document.querySelector("select#types");
let sectors__select = document.querySelector("select#sectors");
const lang = document.documentElement.lang;
const brokerSearchForm = document.querySelector("#brokerSearch");
const boundsInput = document.querySelector('[name="bounds"]');
const mapSearch = document.querySelector('[name="mapSearch"]');
const mapContainer = document.querySelector("#map");
let map = undefined;
let zoomLevel = 14;
let markers = new L.MarkerClusterGroup({
  chunkedLoading: true,
  chunkInterval: 200,
  chunkDelay: 50,
});
let markerMap = new Map();
let maintainValidMakers = false;

let myIcon = L.icon({
  iconUrl: "/wp-content/uploads/2023/01/marker.svg",
  iconSize: [24, 24],
  iconAnchor: [24, 24],
  popupAnchor: [0, -50],
});

function initMap(coords, zoomLevel) {
  map = L.map("map");
  map.on("load", () => {
    boundsInput.value = getBounds(map).join();
    console.log("bounds", boundsInput.value);
    const params = new URLSearchParams();
    params.set("bounds", boundsInput.value);
    searchListings();
    populateMap(params);
  });
  map.setView(coords, zoomLevel);

  const mapLink = '<a href="https://openstreetmap.org">OpenStreetMap</a>';
  L.tileLayer(
    "https://realestate.marketingwebsites.ca/mapLeaflet/tile/positron/{z}/{x}/{y}",
    {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      tileSize: 512,
      zoomOffset: -1,
    }
  ).addTo(map);

  map.on("moveend", function () {
    zoomLevel = map?.getZoom();
    boundsInput.value = getBounds(map).join();

    if (!form) return;

    form.dataset.byMove = "true";

    const event = new Event("submit", { bubbles: true, cancelable: true });
    form.dispatchEvent(event);
  });
}

if (mapContainer) {
  getUserLocation();
}

function populate(data) {
  if (!data || !data.length) {
    dataContainer.html("<p>No listings found.</p>");
    return;
  }

  let html = propertyTemplate(data);
  dataContainer.html(html);
}

function populateBrokers(data) {
  if (!data || !data.length) {
    dataContainer.html("<p>No brokers found.</p>");
    return;
  }

  let html = brokerTemplate(data);
  brokerDataContainer.html(html);
}

// async function populateMap(params = "") {
//   $.ajax({
//     url: `${ajaxObject.ajax_url}?action=search_listings&${params}&status=EV&limit=10000`,
//     success: (data) => {
//       console.log("populateMap params", params);
//       if (zoomLevel < 13) return "Please zoom in to load results";
//       const results = data?.results || [];
//       const mlsSet = new Set(results.map((p) => p.property.mls_no));

//       if (!maintainValidMakers) {
//         for (let [mls, marker] of markerMap) {
//           if (!mlsSet.has(mls)) {
//             markers.removeLayer(marker);
//             markerMap.delete(mls);
//           }
//         }
//       }

//       results.map((property) => {
//         const mls = property["property"]["mls_no"];

//         if (!markerMap.has(mls)) {
//           let marker = new L.marker(
//             [
//               parseFloat(property["property"]["latitude"]),
//               parseFloat(property["property"]["longitude"]),
//             ],
//             { icon: myIcon }
//           );

//           markerMap.set(mls, marker);

//           marker.addEventListener("click", () => {
//             const mapPopup = popupTemplate(property);
//             marker.bindPopup(mapPopup).openPopup();
//           });
//           markers.addLayer(marker);
//         }
//         //marker.mls = { mls: property["property"]["mls_no"] };
//       });

//       map.addLayer(markers);
//     },
//   });
// }

async function populateMap(params = "") {
  const url = `${ajaxObject.ajax_url}?action=search_listings&${params}&status=EV&limit=10000`;

  try {
    const response = await fetch(url);
    const data = await response.json();

    console.log("populateMap params", params);

    if (zoomLevel < 13) return "Please zoom in to load results";

    const results = data?.results || [];
    const mlsSet = new Set(results.map((p) => p.property.mls_no));

    if (!maintainValidMakers) {
      for (let [mls, marker] of markerMap) {
        if (!mlsSet.has(mls)) {
          markers.removeLayer(marker);
          markerMap.delete(mls);
        }
      }
    }

    results.forEach((property) => {
      const mls = property["property"]["mls_no"];

      if (!markerMap.has(mls)) {
        const marker = new L.marker(
          [
            parseFloat(property["property"]["latitude"]),
            parseFloat(property["property"]["longitude"]),
          ],
          { icon: myIcon }
        );

        markerMap.set(mls, marker);

        marker.addEventListener("click", () => {
          const mapPopup = popupTemplate(property);
          marker.bindPopup(mapPopup).openPopup();
        });

        markers.addLayer(marker);
      }
    });

    map.addLayer(markers);
  } catch (error) {
    console.error("Error fetching map data:", error);
  }
}

async function searchListings(params = "") {
  let pageSize = 9;
  if (mapSearch && mapSearch.value) {
    pageSize = 21;
  }
  return pagination(paginationContainer, {
    dataSource: `${ajaxObject.ajax_url}?action=search_listings&${params}`,
    ajax: {
      beforeSend: function (xhr, data) {
        dataContainer.html(`
                        <div class="loading-spinner">
                            <p>Loading...</p>
                        </div>
                    `);

        let url = new URL(data.url);
        const startParam = +url.searchParams.get("start") || 1;
        url.searchParams.set("start", ((startParam - 1) * pageSize).toString());
        data.url = url.href;

        window.scrollTo({
          top: listingSection.offsetTop,
          behavior: "smooth",
        });
        console.log("endpoint:", data.url);
      },
    },
    totalNumberLocator: (response) => response.results_count,
    pageSize: pageSize,
    locator: "results",
    alias: {
      pageNumber: "start",
      pageSize: "limit",
    },
    callback: (data, pagination) => {
      populate(data);
    },
  });
}

if (form) {
  form.addEventListener("submit", (e) => {
    e.preventDefault();

    if (form.dataset.byMove === "true") {
      maintainValidMakers = true;
    } else {
      maintainValidMakers = false;
    }

    form.dataset.byMove = "false";

    let regions_arr = [];
    let municipalities_arr = [];
    let region_select = document.querySelector('[name="region"]');
    const municipalities_select = document.querySelector(
      '[name="municipalities"]'
    );
    let url = new URL(window.location.href);
    let searchParams = new URLSearchParams(url.search);
    searchParams.forEach((_, key) => searchParams.delete(key));

    if (sale_status.value === "rent") {
      searchParams.delete("price_min");
      searchParams.delete("price_max");
    } else if (sale_status.value === "sale") {
      searchParams.delete("price_rent_min");
      searchParams.delete("price_rent_max");
    }

    new FormData(form).forEach((value, key) => {
      if (value) searchParams.set(key, value);
    });

    if (region_select) {
      for (let option of region_select.options) {
        if (option.selected) regions_arr.push(option.value);
      }

      if (regions_arr.length)
        searchParams.set("region_code", regions_arr.join());
    }

    if (municipalities_select) {
      for (let option of municipalities_select.options) {
        if (option.selected) municipalities_arr.push(option.value);
      }

      if (municipalities_arr.length)
        searchParams.set("municipality_code", municipalities_arr.join());
    }

    url.search = searchParams.toString();
    //window.location.href = url.toString();
    //console.log(searchParams);
    searchListings(searchParams);
    if (mapSearch.value) {
      populateMap(searchParams);
    }
  });
}

if (brokerSearchForm) {
  brokerSearchForm.addEventListener("submit", (e) => {
    e.preventDefault();
    const formData = new FormData(brokerSearchForm);
    const name = formData.get("name");

    searchBroker(name);
  });
}

if (sale_status) {
  sale_status.onchange = (e) => {
    minPrice.value = "";
    maxPrice.value = "";

    if (e.target.value === "rent") {
      minPrice.setAttribute("name", "price_rent_min");
      maxPrice.setAttribute("name", "price_rent_max");
    } else if (e.target.value === "sale") {
      minPrice.setAttribute("name", "price_min");
      maxPrice.setAttribute("name", "price_max");
    }
  };
}

async function getPropertiesByRegion(code) {
  return paginationContainer.pagination({
    dataSource: `${ajaxObject.ajax_url}?action=get_region_listings&region_code=${code}`,
    ajax: {
      beforeSend: function (xhr, data) {
        dataContainer.html(`
                        <div class="loading-spinner">
                            <p>Loading...</p>
                        </div>
                    `);

        let url = new URL(data.url);
        const startParam = +url.searchParams.get("start") || 1;
        const pageSize = 9;

        url.searchParams.set("start", ((startParam - 1) * pageSize).toString());
        data.url = url.href;

        window.scrollTo({
          top: listingSection.offsetTop,
          behavior: "smooth",
        });
        console.log("endpoint:", data.url);
      },
    },
    totalNumberLocator: (response) => response.results_count,
    pageSize: 9,
    locator: "results",
    alias: {
      pageNumber: "start",
      pageSize: "limit",
    },
    callback: (data, pagination) => {
      populate(data);
    },
  });
}

async function searchBroker(name) {
  return paginationContainer.pagination({
    dataSource: `${ajaxObject.ajax_url}?action=search_broker&name=${name}`,
    ajax: {
      beforeSend: function (xhr, data) {
        dataContainer.html(`
                        <div class="loading-spinner">
                            <p>Loading...</p>
                        </div>
                    `);

        let url = new URL(data.url);
        const startParam = +url.searchParams.get("start") || 1;
        const pageSize = 9;

        url.searchParams.set("start", ((startParam - 1) * pageSize).toString());
        data.url = url.href;

        window.scrollTo({
          top: brokersSection.offsetTop,
          behavior: "smooth",
        });
        console.log("endpoint:", data.url);
      },
    },
    totalNumberLocator: (response) => response.results_count,
    pageSize: 9,
    locator: "results",
    alias: {
      pageNumber: "start",
      pageSize: "limit",
    },
    callback: (data, pagination) => {
      populateBrokers(data);
    },
  });
}

async function getBrokerListings(code) {
  return paginationContainer.pagination({
    dataSource: `${ajaxObject.ajax_url}?action=get_broker_listings&code=${code}`,
    ajax: {
      beforeSend: function (xhr, data) {
        dataContainer.html(`
                        <div class="loading-spinner">
                            <p>Loading...</p>
                        </div>
                    `);

        let url = new URL(data.url);
        const startParam = +url.searchParams.get("start") || 1;
        const pageSize = 9;

        url.searchParams.set("start", ((startParam - 1) * pageSize).toString());
        data.url = url.href;

        window.scrollTo({
          top: listingSection.offsetTop,
          behavior: "smooth",
        });
        console.log("endpoint:", data.url);
      },
    },
    totalNumberLocator: (response) => response.results_count,
    pageSize: 9,
    locator: "results",
    alias: {
      pageNumber: "start",
      pageSize: "limit",
    },
    callback: (data, pagination) => {
      populate(data);
    },
  });
}

async function getPropertiesByMunicipality(code) {
  return paginationContainer.pagination({
    dataSource: `${ajaxObject.ajax_url}?action=get_municipality_listings&municipality_code=${code}`,
    ajax: {
      beforeSend: function (xhr, data) {
        dataContainer.html(`
                        <div class="loading-spinner">
                            <p>Loading...</p>
                        </div>
                    `);

        let url = new URL(data.url);
        const startParam = +url.searchParams.get("start") || 1;
        const pageSize = 9;

        url.searchParams.set("start", ((startParam - 1) * pageSize).toString());
        data.url = url.href;

        window.scrollTo({
          top: listingSection.offsetTop,
          behavior: "smooth",
        });
        console.log("endpoint:", data.url);
      },
    },
    totalNumberLocator: (response) => response.results_count,
    pageSize: 9,
    locator: "results",
    alias: {
      pageNumber: "start",
      pageSize: "limit",
    },
    callback: (data, pagination) => {
      populate(data);
    },
  });
}

async function getAgents() {
  return paginationContainer.pagination({
    dataSource: `${ajaxObject.ajax_url}?action=get_agents`,
    ajax: {
      beforeSend: function (xhr, data) {
        dataContainer.html(`
                        <div class="loading-spinner">
                            <p>Loading...</p>
                        </div>
                    `);

        let url = new URL(data.url);
        const startParam = +url.searchParams.get("start") || 1;
        const pageSize = 9;

        url.searchParams.set("start", ((startParam - 1) * pageSize).toString());
        data.url = url.href;

        window.scrollTo({
          top: brokersSection.offsetTop,
          behavior: "smooth",
        });
        console.log("endpoint:", data.url);
      },
    },
    totalNumberLocator: (response) => response.results_count,
    pageSize: 9,
    locator: "results",
    alias: {
      pageNumber: "start",
      pageSize: "limit",
    },
    callback: (data, pagination) => {
      populateBrokers(data);
    },
  });
}

function popupTemplate(property) {
  return `<a href="/properties/${property["property"]["civic_number_start"]}+${
    property["property"]["street_name"]
  }/${property["property"]["mls_no"]}">
                                <div class="map-popup">
                                    <div class="img">
                                        <img src="${
                                          property["images"][0]["thumburl"]
                                        }" data-src="${
    property["images"][0]
      ? property["images"][0]["photourl"]
      : "/wp-content/uploads/2023/01/dummy.jpg"
  }" alt="${property["property"]["mls_no"]}"
                                                    class="lazyload">
                                    </div>
                                    <div class="inner">
                                        <p class="address">${
                                          property["property"][
                                            "civic_number_start"
                                          ]
                                        } ${
    property["property"]["street_name"]
  }</p>
                                        <p class="municipality">${
                                          property["property"][
                                            "municipality_name"
                                          ]
                                        }</p>
                                    </div>
                                </div>
                             </a>`;
}

function propertyTemplate(data) {
  let html = '<div class="flexBox">';
  data?.map((property) => {
    html += `
        <div class="customGrid">
            <div class="properti_city home6">
                <a class="openProperty" href="/properties/${
                  property.property.civic_number_start
                }+${property.property.street_name}/${property.property.mls_no}">
                    <div class="thumb">
                        <img class="img-fluid w100 lazyload" 
                        src="${property.images[0].thumburl}" data-src="${
      property.images[0].photourl
    }">
                    </div>
                </a>

                <a href="/properties/${property.property.civic_number_start}+${
      property.property.street_name
    }/${property.property.mls_no}">
                    <div class="overlay">
                        <div class="details">
                            <h3 class="fp_price color-white">$${displayPrice(
                              property
                            )}</h3>
                            <h4>${property.property.civic_number_start} ${
      property.property.street_name
    }<br>${property.property.municipality_name}</h4>
                            <h5 class="color-white">MLS# ${
                              property.property.mls_no
                            }</h5>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    `;
  });

  html += "</div>";
  return html;
}

function displayPrice(property) {
  if (
    property.property.price_buy !== "0" &&
    property.property.price_rent !== "0"
  )
    return `${numberFormat(property.property.price_buy)} or ${numberFormat(
      property.property.price_rent
    )}/${property.property.price_rent_per}`;
  else if (
    property.property.price_buy !== "0" &&
    property.property.price_rent === "0"
  )
    return numberFormat(property.property.price_buy);
  else
    return `${numberFormat(property.property.price_rent)}/${
      property.property.price_rent_per
    }`;
}

function numberFormat(number) {
  return new Intl.NumberFormat().format(number);
}

function brokerTemplate(data) {
  let url = "";
  if (document.documentElement.lang === "en") {
    url = "/en/single-agent/";
  } else {
    url = "/courtier/";
  }
  let html = "";
  html += '<div class="row">';
  data?.map((agent) => {
    html += `<div class="col-lg-6 col-sm-12 col-xs-12 mb-4">
                <div class="row m-0 bg-white p-2">
                    <div class="col-lg-4 col-sm-4 col-xs-12">
                        <div class="broker-img">
                            <a href="${url}?agent=${agent["prenom"]}~${agent["nom"]}">
                                <img data-src="${agent["photo_url"]}" class="lazyload" alt="${agent["prenom"]} ${agent["nom"]}">
                            </a>
                        </div>
                    </div>

                    <div class="col-lg-8 col-sm-8 col-xs-12">
                        <div class="inner-broker-info">
                            <h4>${agent["prenom"]} ${agent["nom"]}</h4>
                        </div>
                    </div>
                </div>
            </div>`;
  });
  html += "</div>";
  return html;
}

function formatPhoneNumber(phoneNumberString) {
  let cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return "";
}

if (type__select && sectors__select) {
  if (lang === "en-US") {
    type__select.setAttribute("js-placeholder", "Property type");
    sectors__select.setAttribute("js-placeholder", "Sectors");
  } else {
    type__select.setAttribute("js-placeholder", "Type de propriété");
    sectors__select.setAttribute("js-placeholder", "Secteurs");
  }
}

function getBounds(map) {
  return [
    map.getBounds().getNorth(),
    map.getBounds().getEast(),
    map.getBounds().getSouth(),
    map.getBounds().getWest(),
  ];
}

document.addEventListener("DOMContentLoaded", () => {
  if ($(".show-form").length > 0) {
    $(".show-form").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("click");
      $(".wd-search-form").toggleClass("show");
    });
  }
});

function getUserLocation() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(success, error);
  } else {
    console.error("Geolocation is not supported by this browser.");
    initMap([45.5019, -73.5674], zoomLevel);
  }
}

function success(position) {
  let userCurrentLocation = [
    position.coords.latitude,
    position.coords.longitude,
  ];
  initMap(userCurrentLocation, 15);
}

function error() {
  alert("Location access denied");
  initMap([45.5019, -73.5674], zoomLevel);
}

window.searchListings = searchListings;

console.log("app.js from plugin is loaded");
